import * as React from 'react'
function SvgSignDoc(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 32a2 2 0 110 4H6a2 2 0 110-4h28zM21.8 5.4c1.8-1.8 5-1.8 6.8 0 1.8 1.8 1.8 5 0 6.8l-.8.8 3 3c.8.8.8 2 0 2.8l-6 6A1.98 1.98 0 0122 22l4.6-4.6-1.6-1.6-11.614 11.614a2 2 0 01-1.414.586H6v-5.972a2 2 0 01.586-1.414z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgSignDoc
